<style lang="css" scoped>
    .card-body {
        position: relative;
    }

    #helptext-trigger {
        position: absolute;
        pointer-events: auto;
        z-index: 1;
        top: 15px;
        right: 15px;
    }
</style>


<template>
    <div id="filter-container" class="card helptext-container">
        <div class="card-body">
            <font-awesome-icon
                    id="helptext-trigger"
                    icon="question-circle"
                    class="cursor-pointer d-none d-md-inline"
                    @click="helpTexts = !helpTexts"
            />
            <b-form>
                <div class="row">
                    <div class="col-md-4">
                        <label for="notionFilter">{{$t('userAnswers.fields.notion')}}</label>
                        <b-form-select
                                id="notionFilter"
                                v-model="notion"
                                :options="notionOptions"
                                class="mb-3"
                        />
                    </div>
                    <div class="col-md-4">
                        <label for="visionFilter">{{$t('userAnswers.fields.vision')}}</label>
                        <b-form-select
                                id="visionFilter"
                                v-model="vision"
                                :options="visionOptions"
                                class="mb-3"
                        />
                    </div>
                    <div class="col-md-4">
                        <label for="themeFilter">{{$t('userAnswers.fields.theme')}}</label>
                        <b-form-select id="themeFilter" v-model="theme" :options="themeOptions" class="mb-3"/>
                    </div>
                </div>
                <div class="row d-flex align-items-center">
                    <div class="col-md-4 mb-3 mb-md-0">
                        <label>
                            {{$t('userAnswers.fields.gaugeLevel')}}
                            <!--<b>{{stats.gaugeLevelAvg}}%</b>-->
                        </label>
                        <vue-slider
                                ref="gaugeSlider"
                                id="gauge-poptarget"
                                v-model="gaugeLevel"
                                v-bind="gaugeLevelOptions"
                        ></vue-slider>
                        <b-popover
                                target="gauge-poptarget"
                                placement="bottom"
                                container="#filter-container"
                                :show.sync="helpTexts"
                                triggers
                                :title="$t('userAnswers.stats.helptexts.gaugeTitle')"
                        >{{$t('userAnswers.stats.helptexts.gauge')}}
                        </b-popover>
                    </div>
                    <div class="col-md-8">
                        <span id="action-poptarget">
                            <b-form-checkbox stacked v-model="isAction">
                              {{$t('userAnswers.fields.action')}}
                              <b>{{stats.isActionAvg}}%</b>
                            </b-form-checkbox>
                        </span>
                        <b-popover
                                target="action-poptarget"
                                placement="top"
                                container="#filter-container"
                                :show.sync="helpTexts"
                                triggers
                                :title="$t('userAnswers.stats.helptexts.actionTitle')"
                        >{{$t('userAnswers.stats.helptexts.action')}}
                        </b-popover>

                        <span id="fantasy-poptarget">
                            <b-form-checkbox stacked v-model="isFantasy" :value="true" :unchecked-value="false">
                              {{$t('userAnswers.fields.fantasy')}}
                              <b>{{stats.isFantasyAvg}}%</b>
                            </b-form-checkbox>
                        </span>
                        <b-popover
                                target="fantasy-poptarget"
                                placement="bottom"
                                container="#filter-container"
                                :show.sync="helpTexts"
                                triggers
                                :title="$t('userAnswers.stats.helptexts.fantasyTitle')"
                        >{{$t('userAnswers.stats.helptexts.fantasy')}}
                        </b-popover>

                        <span id="skipped-poptarget">
                            <b-form-checkbox stacked v-model="isSkipped" :value="true" :unchecked-value="false">
                              {{$t('userAnswers.fields.skipped')}}
                              <b>{{stats.isSkippedAvg}}%</b>
                            </b-form-checkbox>
                        </span>
                        <b-popover
                                target="skipped-poptarget"
                                placement="top"
                                container="#filter-container"
                                :show.sync="helpTexts"
                                triggers
                                :title="$t('userAnswers.stats.helptexts.skippedTitle')"
                        >{{$t('userAnswers.stats.helptexts.skipped')}}
                        </b-popover>
                        <span id="bookmark-poptarget">
                            <b-form-checkbox stacked v-model="isBookmarked" :value="true" :unchecked-value="false">
                              {{$t('userAnswers.fields.bookmark')}}
                              <b>{{stats.bookmarkAvg}}%</b>
                            </b-form-checkbox>
                        </span>
                        <b-popover
                                target="bookmark-poptarget"
                                placement="bottom"
                                container="#filter-container"
                                :show.sync="helpTexts"
                                triggers
                                :title="$t('userAnswers.stats.helptexts.bookmarkTitle')"
                        >{{$t('userAnswers.stats.helptexts.bookmark')}}
                        </b-popover>
                    </div>
                </div>
            </b-form>
        </div>
    </div>
</template>
<script>
import {gaugeLevelOptions} from './stats-options-slider';
import vueSlider from 'vue-slider-component';
import {mapGetters} from 'vuex';

export default {
    components: {vueSlider},
    props: {
        baseAnswersUrl: {},
        baseStatsUrl: {},
        storeMethod: {},
        stats: {},
        contactId: {},
        defaultFilters: {type: Object},
    },
    data: function () {
        return {
            notion: this.defaultFilters && this.defaultFilters.hasOwnProperty('notion') ? this.defaultFilters.notion : '',
            vision: this.defaultFilters && this.defaultFilters.hasOwnProperty('vision') ? this.defaultFilters.vision : '',
            theme: this.defaultFilters && this.defaultFilters.hasOwnProperty('theme') ? this.defaultFilters.theme : '',
            isAction: this.defaultFilters && this.defaultFilters.hasOwnProperty('isAction') ? this.defaultFilters.isAction : false,
            isFantasy: this.defaultFilters && this.defaultFilters.hasOwnProperty('isFantasy') ? this.defaultFilters.isFantasy : false,
            isSkipped: this.defaultFilters && this.defaultFilters.hasOwnProperty('isSkipped') ? this.defaultFilters.isSkipped : false,
            gaugeLevel: this.defaultFilters && this.defaultFilters.hasOwnProperty('gaugeLevel') ? this.defaultFilters.gaugeLevel : [gaugeLevelOptions.min, gaugeLevelOptions.max],
            isBookmarked: this.defaultFilters && this.defaultFilters.hasOwnProperty('bookmark') ? this.defaultFilters.bookmark : false,
            gaugeLevelOptions: gaugeLevelOptions,
            helpTexts: false,
        };
    },
    computed: {
        ...mapGetters({
            notions: 'notion/list/notions',
            visions: 'vision/list/visions',
            themes: 'theme/list/themes',
        }),
        notionOptions: function () {
            let options = this.notions.map(notion => {
                return {value: notion.id, text: notion.label};
            });
            options.unshift({value: '', text: ''});
            return options;
        },
        visionOptions: function () {
            let options = this.visions.map(vision => {
                return {value: vision.id, text: vision.label};
            });
            options.unshift({value: '', text: ''});
            return options;
        },
        themeOptions: function () {
            let options = this.themes.map(theme => {
                return {value: theme.id, text: theme.label};
            });
            options.unshift({value: '', text: ''});
            return options;
        },
        urlFilter: function () {
            let filter = '';
            if (this.notion) {
                filter += '&question.notion=' + this.notion;
            }
            if (this.vision) {
                filter += '&question.vision=' + this.vision;
            }
            if (this.theme) {
                filter += '&question.theme=' + this.theme;
            }
            if (this.isAction) {
                filter += '&isAction=' + this.isAction;
            }
            if (this.isFantasy) {
                filter += '&isFantasy=' + this.isFantasy;
            }
            if (this.isBookmarked) {
                filter += '&bookmark=' + this.isBookmarked;
            }
            if (this.isSkipped) {
                filter += '&isFantasy=false&isAction=false&answer[exists]=false';
            }
            if (
                this.gaugeLevel[0] !== gaugeLevelOptions.min ||
                this.gaugeLevel[1] !== gaugeLevelOptions.max
            ) {
                filter +=
                    '&gaugeLevel[between]=' +
                    this.gaugeLevel[0] +
                    '..' +
                    this.gaugeLevel[1];
            }
            return filter;
        },
        urlOrder() {
            if (this.urlFilter === '') {
                return '?order[id]=asc'
            } else {
                return '?order[answer.weight]=desc&order[gaugeLevel]=desc&order[id]=asc'
            }
        },
    },
    watch: {
        gaugeLevel: function (newValue) {
            if (
                newValue[0] !== gaugeLevelOptions.min ||
                newValue[1] !== gaugeLevelOptions.max
            ) {
                this.isSkipped = false;
            }
        },
        isAction: function (newValue) {
            if (newValue) {
                this.isSkipped = false;
                this.isFantasy = false;
            }
        },
        isFantasy: function (newValue) {
            if (newValue) {
                this.isSkipped = false;
                this.isAction = false;
            }
        },
        isSkipped: function (newValue) {
            if (newValue) {
                this.isAction = false;
                this.isFantasy = false;
                this.gaugeLevel = [gaugeLevelOptions.min, gaugeLevelOptions.max];
            }
        },
        urlFilter: function (newFilter) {
            this.$store.dispatch(this.storeMethod, {
                listUrl: this.baseAnswersUrl + this.urlOrder + newFilter,
                statsUrl: this.baseStatsUrl + newFilter.replace('&', '?'),
            });
        },
    },
    methods: {
        refresh() {
            this.$refs.gaugeSlider.refresh();
        },
    },
    created() {
        this.$store.dispatch('notion/list/getList', this.contactId);
        this.$store.dispatch('vision/list/getList', this.contactId);
        this.$store.dispatch('theme/list/getList', this.contactId);
        this.$store.dispatch(this.storeMethod, {
            listUrl: this.baseAnswersUrl + this.urlOrder + this.urlFilter,
            statsUrl: this.baseStatsUrl + this.urlFilter.replace('&', '?'),
        });
    },
};
</script>



// WEBPACK FOOTER //
// src/components/app/Filters.vue